/**
 * TextContentTab Component
 * Tab content for creating text-based documents
 * Pure presentational component
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import { TextContentTabProps } from '../types';

export const TextContentTab: React.FC<TextContentTabProps> = ({
  value,
  onChange,
  error
}) => {
  const { t } = useTranslation();

  return (
    <TextField
      required
      fullWidth
      label={t('documents.dialog.content')}
      name="content"
      value={value}
      onChange={onChange}
      multiline
      rows={8}
      helperText={error || t('documents.dialog.contentHelp')}
      error={Boolean(error)}
    />
  );
};
